import React, { useState } from "react";
import { createPortal } from "react-dom";

export default function TooltipPortal({ children, label, enabled = true }) {
  const [pos, setPos] = useState(null);

  const show = (e) => {
    if (!enabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setPos({
      top: rect.top + rect.height / 2,
      left: rect.right + 15,
    });
  };

  const hide = () => setPos(null);

  return (
    <>
      <span onMouseEnter={show} onMouseLeave={hide} onClick={hide}>
        {children}
      </span>

      {pos &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              transform: "translateY(-50%)",
              border: "1px solid rgba(0, 0, 0, 0.15)",
              boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
              background: "white",
              color: "black",
              padding: "5px 10px",
              fontSize: "13px",
              borderRadius: "6px",
              pointerEvents: "none",
              zIndex: 9999,
            }}
            className="tooltip-admin"
          >
            {label}
          </div>,
          document.body,
        )}
    </>
  );
}
